import { Backdrop, Drawer, Stack, styled } from "@mui/material";

export const StlyedDrawer = styled(Drawer)`
    .MuiDrawer-paper {
        width: 25%;
        background-color: rgb(11 60 43);
        color: #ffffff;
        padding: 10px;

        @media (max-width: 1024px) {
          width: 35%;
        }

        @media (max-width: 768px) {
          width: 50%;
        }

        @media (max-width: 576px) {
          width: 75%;
        }
    }
`

export const StyledBackdrop = styled(Backdrop)`
  background-color: #0b3d2c9e;
`

export const DrawerContent = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: '16px 0px',
}))